"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAccountTaxObjectToJSON = exports.AdAccountTaxObjectFromJSONTyped = exports.AdAccountTaxObjectFromJSON = exports.instanceOfAdAccountTaxObject = exports.AdAccountTaxObjectTypeEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.AdAccountTaxObjectTypeEnum = {
    Vat: 'VAT',
    Gst: 'GST',
    Qst: 'QST',
    Abn: 'ABN',
    Cnpj: 'CNPJ',
    Pan: 'PAN',
    Tan: 'TAN'
};
/**
 * Check if a given object implements the AdAccountTaxObject interface.
 */
function instanceOfAdAccountTaxObject(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdAccountTaxObject = instanceOfAdAccountTaxObject;
function AdAccountTaxObjectFromJSON(json) {
    return AdAccountTaxObjectFromJSONTyped(json, false);
}
exports.AdAccountTaxObjectFromJSON = AdAccountTaxObjectFromJSON;
function AdAccountTaxObjectFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : json['type'],
    };
}
exports.AdAccountTaxObjectFromJSONTyped = AdAccountTaxObjectFromJSONTyped;
function AdAccountTaxObjectToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'type': value.type,
    };
}
exports.AdAccountTaxObjectToJSON = AdAccountTaxObjectToJSON;
